export const colors = [
  '#00FF00',
  '#FF0000',
  '#0000FF',
  '#FF00FF',
  '#FFA500',
  '#800080',
  '#008000',
  '#000080',
  '#800000',
  '#008080',
  '#FFC0CB',
  '#FFD700',
  '#A52A2A',
  '#808080',
  '#FF1493',
  '#FF4500',
  '#5574A6',
  '#3B3EAC',
  '#DD4477',
  '#990099',
  '#994499',
];
export const permissions = {
  ANALYTICS_DASHBOARD_USER: 'ANALYTICS_DASHBOARD_USER',
  CAPITAL_USER: 'CAPITAL_USER',
};
